import React from "react";
import { ExternalLink, Download } from "lucide-react";

const MediaCard = ({ title, date, excerpt, category, link, image, downloadLink }) => (
  <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
    {image && (
      <img src={image} alt={title} className="w-full h-48 object-cover" />
    )}
    <div className="p-6">
      <div className="flex items-center justify-between mb-4">
        <span className="px-3 py-1 bg-red-100 text-red-600 rounded-full text-sm font-medium">
          {category}
        </span>
        <span className="text-gray-500 text-sm">{date}</span>
      </div>
      <h3 className="text-xl font-bold text-gray-900 mb-3">{title}</h3>
      <p className="text-gray-600 mb-4">{excerpt}</p>
      <div className="flex items-center gap-3">
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center text-red-600 hover:text-red-700 font-medium"
        >
          Read More <ExternalLink className="w-4 h-4 ml-2" />
        </a>
        {downloadLink && (
          <a
            href={downloadLink}
            download
            className="inline-flex items-center text-gray-600 hover:text-gray-900 font-medium"
          >
            Download <Download className="w-4 h-4 ml-2" />
          </a>
        )}
      </div>
    </div>
  </div>
);

export default MediaCard;
